import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-perspective',
  templateUrl: './perspective.component.html',
  styleUrls: ['./perspective.component.scss']
})
export class PerspectiveComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
